/**
 * Integracoes.
 *
 * Hoje so o GitLab, e por projeto. A aba de branch/MR/commit no card so existe
 * quando o projeto tem vinculo -- desligado, ela nao aparece, e nao aparece
 * vazia. Aba vazia parece defeito.
 */
export const nav = {
    permissao: 'deck.integracoes:ver',
    section: 'Configuracao',
    title: 'Integracoes',
    icon: 'hub',
    route: '/integracoes',
    sequence: 42,
};

export default [
    {
        path: '/integracoes',
        name: 'integracoes',
        component: () => import('./pages/IntegracoesPage.vue'),
        meta: { requiresAuth: true, permissao: 'deck.integracoes:ver' },
    },
];
